import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const signIn = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.auth.LOGIN,
    data: data,
  });
  return request;
};

export const updateProfile = async (id, data) => {
  let request = await axios({
    method: "PUT",
    url: `${endpoints.auth.UPDATE_PROFILE}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const getProfile = async () => {
  let request = await axios({
    method: "GET",
    url: `${endpoints.auth.GET_PROFILE}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const changePassword = async (id, data, token) => {
  let request = await axios({
    method: "PUT",
    url: `${endpoints.auth.CHANGE_PASSWORD}/${id}`,
    headers: {
      Authorization: token,
    },
    data: data,
  });
  return request;
};

export const resetPassword = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.auth.RESET_PASSWORD,
    headers: {
      Authorization: "",
    },
    data: data,
  });
  return request;
};

// export const forgotPassword = async (data) => {
//   let request = await axios({
//     method: "PUT",
//     url: endpoints.auth.FORGOT_PASSWORD,
//     headers: {
//       Authorization: "",
//     },
//     data: data,
//   });
//   return request;
// };
